<template>
    <Popup
        :modelValue="popup_status"
        @update:modelValue="change_popup_status"
    >
        <div>
            <h2 class="sc-dPwPAC NZWAX MuiTypography-root MuiTypography-h6 sc-hKhKOZ iGnsaF MuiDialogTitle-root sc-frdOdM fSHBjj"
                id="alert-dialog-title">{{ popup_title }}</h2>

            <div class="sc-jroJWT cjxrqv MuiDialogContent-root sc-jCSOZN gYvYVW">
                <div
                    class="sc-fxAUDG dkAsfB MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-auto sc-iGpXO eVipCF">
                    <div class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto">
                        <img
                        class="sc-fwEaKe hNHrFH MuiBox-root"
                        src="/images/icons8-calling-96.png"
                        alt="none"></div>
                    <div class="sc-fxAUDG eJKDQJ MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true">
                        <div class="sc-fxAUDG iywvKp MuiGrid-root sc-euvqTP jewETQ">Allow us to help you faster</div>
                        <div class="sc-fxAUDG iywvKp MuiGrid-root sc-eApCZl cBUuXO">Please have your trademark name and serial number ready.
                        </div>
                    </div>
                </div>
            </div>

            <div class="sc-fxAUDG hcKOLN MuiGrid-root MuiGrid-container sc-gEwNfY icvkkr">
                <div
                    class="sc-fxAUDG jdPQkx MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true sc-jxYjqv lfiDsb">
                    <div
                        class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto sc-mJJYm fYiJnW">
                        Speak with a Rep
                    </div>
                    <div
                        class="sc-fxAUDG eJKDQJ MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true sc-eZlUYB bTXeoO">
                        <div class="sc-fwEaKe sc-hdtffo chiHgX MuiBox-root">Connect with us during business hours
                            Chat Now:
                        </div>
                        <div class="sc-fwEaKe sc-hdtffo chiHgX MuiBox-root">
                            <div class="sc-fwEaKe MuiBox-root">8:30am to 5:00pm EST</div>
                        </div>
                    </div>
                    <div
                        class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto sc-jWUBpL hiniDM">
                        <button
                            onclick="Chatra('openChat', true)"
                            style="color: #14bcc3"
                            class="sc-dPwPAC NHZAo MuiTypography-root MuiTypography-inherit sc-daSpeN hEeoxt MuiLink-root MuiLink-underlineAlways MuiLink-button">
                            Chat now
                        </button>
                    </div>
                </div>
                <div
                    class="sc-fxAUDG jdPQkx MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true sc-jxYjqv lfiDsb">
                    <div
                        class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto sc-mJJYm fYiJnW">
                        Hop on a call
                    </div>
                    <div
                        class="sc-fxAUDG eJKDQJ MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true sc-eZlUYB bTXeoO">
                        <div class="sc-fwEaKe sc-hdtffo chiHgX MuiBox-root">Call us during our business hours:
                        </div>
                        <div class="sc-fwEaKe sc-hdtffo chiHgX MuiBox-root">
                            <div class="sc-fwEaKe MuiBox-root">8:30am to 5:00pm EST</div>
                        </div>
                    </div>
                    <div
                        class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto sc-jWUBpL hiniDM">
                        <a class="sc-dPwPAC NHZAo MuiTypography-root MuiTypography-inherit sc-daSpeN fChBWt MuiLink-root MuiLink-underlineAlways"
                           href="tel:+2122030957">PH: (212) 203-0957</a></div>
                </div>
                <div
                    class="sc-fxAUDG jdPQkx MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true sc-jxYjqv lfiDsb">
                    <div
                        class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto sc-mJJYm fYiJnW">
                        Email us
                    </div>
                    <div
                        class="sc-fxAUDG eJKDQJ MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true sc-eZlUYB bTXeoO">
                        Email us at your convenience. We will do our best to reply within 2 business days.
                    </div>
                    <div
                        class="sc-fxAUDG fjCipV MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto sc-jWUBpL hiniDM">
                        <a class="sc-dPwPAC NHZAo MuiTypography-root MuiTypography-inherit sc-daSpeN fChBWt MuiLink-root MuiLink-underlineAlways"
                           href="mailto:support@zenbusiness.com">abe@cohntm.com</a></div>
                </div>
            </div>
        </div>
    </Popup>
</template>

<script>
import Popup from '@/components/Popup.vue'
import {mapGetters} from "vuex";

export default {
    components: {
        Popup
    },
    methods: {
        change_popup_status(status) {
            this.$store.commit('header/setPopupStatus', status);
        },
    },
    computed: {
        ...mapGetters('header', {
            popup_status: 'getPopupStatus',
            popup_title: 'getPopupTitle',
        })
    }
}
</script>
